import "./financialDepartment.scss";
import Cards from "./Cards.jsx";
import FinancialTabs from "./FinancialTabs";
import { getInfo } from "./FinancialDepartment";
import { useEffect, useState } from "react";
// import Loader from "../../../utils/Loader";

export default function Index() {
  const [financialInformation, setFinancialInformation] = useState();
  const [updaterFlag, setUpdaterFlag] = useState(false);
  const [transactionList1, setTransactionList1] = useState([]);
  const [transactionList2, setTransactionList2] = useState([]);
  const [transactionList3, setTransactionList3] = useState([]);
  const [transactionListAll, setTransactionListAll] = useState([]);
  const [cardInformation, setCardInformation] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  function compare(a, b) {
    if (a.last_nom < b.last_nom) {
      return -1;
    }
    if (a.last_nom > b.last_nom) {
      return 1;
    }
    return 0;
  }
  function updater() {
    setUpdaterFlag(!updaterFlag);
  }
  useEffect(() => {
    setIsLoading(true);
    setTransactionList1([]);
    setTransactionList2([]);
    setTransactionList3([]);
    setTransactionListAll([]);
    getInfo().then(value => {
      console.log(value, "value");
      setFinancialInformation(value);
      for (let index = 0; index < value["transactionList"].length; index++) {
        setTransactionListAll(prev => [
          ...prev,
          value["transactionList"][index]
        ]);

        switch (value["transactionList"][index].type) {
          case "1":
            console.log(value["transactionList"][index].type, "type");
            setTransactionList1(prev => [
              ...prev,
              value["transactionList"][index]
            ]);
            break;
          case "2":
            console.log(value["transactionList"][index].type, "type");

            setTransactionList2(prev => [
              ...prev,
              value["transactionList"][index]
            ]);
            break;
          case "3":
            console.log(value["transactionList"][index].type, "type");

            setTransactionList3(prev => [
              ...prev,
              value["transactionList"][index]
            ]);
            break;
          default:
            break;
        }
      }
      setIsLoading(false);
    });
  }, [updaterFlag]);

  return (
    <div className="financial-department-container px-sm-3 px-0 w-100 ">
      {/* {isLoading && <Loader></Loader>} */}
      {financialInformation && (
        <>
          <Cards
            financialInformation={financialInformation}
            cardInformation={cardInformation}
          ></Cards>
          <FinancialTabs
            transactionList1={transactionList1}
            transactionList2={transactionList2}
            transactionList3={transactionList3}
            updater={updater}
            userList={financialInformation.userList}
            transactionListAll={transactionListAll}
            isReadOnly={false}
          ></FinancialTabs>
        </>
      )}
    </div>
  );
}
